export default "__VITE_ASSET__mpBqUm1H__"